<template>
  <div class="mt-2" v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.TERMINALS) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))">
    <v-container style="margin-right: 0; margin-left: 0;">
      <v-row style="height: 100%;" class="pl-4">
        <v-col md="5" class="pr-0"  v-if="user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.TERMINALS) || userHasResourceAccess(RESOURCENAMES.TERMINALS_INCOMING) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT)">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Incoming Terminals</h4>
          </v-toolbar>
          <IncomingTerminal />
        </v-col>
        <v-col md="7"  v-if="user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.TERMINALS) || userHasResourceAccess(RESOURCENAMES.TERMINALS_REGISTERED)|| userHasResourceAccess(RESOURCENAMES.MANAGEMENT)">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Registered Terminals</h4>
          </v-toolbar>
          <RegisteredTerminal />
        </v-col>
      </v-row>
      <v-divider style="margin:15px 0 "></v-divider>
      <v-row style="height: 100%;" class="pl-4" v-if="user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.TERMINALS,ROLEACTIONCODE.FULL) || userHasResourceAccess(RESOURCENAMES.TERMINALS_USERS)|| userHasResourceAccess(RESOURCENAMES.MANAGEMENT)" >
        <v-col md="12">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Terminal Users (Tellers)</h4>
          </v-toolbar>
          <TerminalUserManagement />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import IncomingTerminal from '../components/IncomingTerminal.vue'
import RegisteredTerminal from '../components/RegisteredTerminal.vue'
import TerminalUserManagement from '../components/TerminalUserManagement.vue'
import { mapGetters } from 'vuex'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins: [accessControlMixin],
  data () {
    return {}
  },
  components: {
    IncomingTerminal,
    RegisteredTerminal,
    TerminalUserManagement
  },
  mounted () {
    if (this.user.roles && (!this.user.roles.includes('*') && !this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS) && !this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT))) {
      if (this.$route && this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  },
  computed: {
    ...mapGetters(['getUserLoggedIn']),
    user () {
      return this.getUserLoggedIn
    }
  }
}
</script>

<style scoped>
  .apiContainer {
    display: flex;
    flex-direction: column;
    height:inherit;
  }

  @media (min-width: 1264px) {
    .container {
      max-width: 100%;
    }
  }
</style>
